import VideoWithFallback from "../../../VideoWithFallback";
import ProductHeroContainer from "../../../../../ProductHeroContainer";
import styles from "./index.css";

const EagerVideo = props => (
  <ProductHeroContainer className={styles.productTileProductHero}>
    <VideoWithFallback {...props} />
  </ProductHeroContainer>
);

export default EagerVideo;
